import './AssetBox.css';
import { Link } from 'react-router-dom';
import { IoMdSwap } from 'react-icons/io';
import { FiArrowDownRight, FiArrowUpLeft } from 'react-icons/fi';

interface AssetBoxProps {
    coin: string;
    coinsData: any;
    balanceData: any;
    pairsData: any;
    coinlogos: any;
    t: (key: string) => string;
    setModalContent: (content: JSX.Element) => void;
    numberWithCommas: (value: string, decimals: number) => string;
    filteredCoins: () => string[];
    AssetModal: React.ComponentType<{ coin: string }>;
    getFirstPairForAsset: (pairsData: any, coin: string) => any;
}

const AssetBox = ({
    coin,
    coinsData,
    balanceData,
    pairsData,
    coinlogos,
    t,
    numberWithCommas,
    getFirstPairForAsset
}: AssetBoxProps) => {
    if (!coinsData || !balanceData) return null;

    const currencySymbols: Record<string, string> = {
        USDT: '$',
        PEN: 'S/',
        COP: '$',
        USD: '$'
    };

    const isUSD = ['USDT', 'USD']

    const firstPair = getFirstPairForAsset(pairsData, coin);
    const totalBalance = balanceData.balance[coin].actual + balanceData.balance[coin].orders;
    const usdtValue = coinsData.coins[coin].price * totalBalance;
    const price24hPercent = coinsData.coins[coin].price_24h_percent;


    return (
        <div className="asset-box-cont">
            <div className="asset-box-main-content">
                <div className="asset-box-top">
                    <div className="asset-top-coinlogo">
                        <img
                            src={coinlogos[coin as keyof typeof coinlogos]}
                            alt={coin}
                            style={{ width: '32px', height: '32px' }}
                        />
                    </div>
                    <div className="asset-top-coinname">
                        <div className="asset-top-coinname-name">
                            {t(`long_coin_names.${coin}`)}
                        </div>
                        <div className="asset-top-coinname-tick">
                            {coin}
                        </div>
                    </div>

                </div>

                <div className="asset-box-body">
                    <div className="asset-body-coin">
                        <div className="asset-body-coinvalue">
                            {currencySymbols[coin] || ''} {numberWithCommas(`${totalBalance}`, coinsData?.coins[coin]?.decimals)}
                        </div>

                    </div>
                </div>

                {!isUSD.includes(coin) && (
                    <div className="asset-box-bottom">
                        <div className="asset-bottom-titles">
                            <div className="usdt-to-coin">

                            </div>
                            <div className="24h-change">
                                24h Change
                            </div>
                        </div>
                        <div className="asset-bottom-value">

                            {!isUSD.includes(coin) && (
                                <div className="asset-body-usdt-value">
                                    ≈ {numberWithCommas(`${usdtValue}`, 2)} USDT
                                </div>
                            )}
                            <div className={`asset-bottom-coinvalue-change ${price24hPercent === 0 ? 'neutral' :
                                price24hPercent > 0 ? 'positive' : 'negative'
                                }`}>
                                {price24hPercent >= 0 ? '+' : ''}{price24hPercent.toFixed(2)}%
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div className="asset-box-actions-column">
                <Link className="asset-item-action-link" to={`/converter/${coin}/${firstPair ? firstPair.quote : "USDT"}`}>
                    <IoMdSwap color='var(--main-primary)' />
                </Link>
                <Link className="asset-item-action-link" to={`/deposit/${coin}`}>
                    <FiArrowDownRight color='var(--main-primary)' />
                </Link>
                <Link className="asset-item-action-link" to={`/withdraw/${coin}`}>
                    <FiArrowUpLeft color='var(--main-primary)' />
                </Link>

            </div>
        </div>
    );
};

export default AssetBox;